var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUnknownNew(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 24,
    height: 24,
    viewBox: "0 0 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient",
    cx: 0.5,
    cy: 0.5,
    r: 0.5,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#dadada"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_75551",
    "data-name": "Group 75551",
    transform: "translate(-229 -591)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Flux_logo_blue_black",
    transform: "translate(228.771 591.498)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_64",
    "data-name": "Ellipse 64",
    cx: 16,
    cy: 16,
    r: 16,
    transform: "translate(0.229 -0.498)",
    fill: "#dadada"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_3180",
    "data-name": "Ellipse 3180",
    cx: 10,
    cy: 10,
    r: 10,
    transform: "translate(6.229 5.502)",
    stroke: "rgba(0,0,0,0)",
    strokeMiterlimit: 10,
    strokeWidth: 1,
    fill: "url(#radial-gradient)"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_71098",
    "data-name": "Path 71098",
    d: "M4.144-3.552h1.28v-.256c0-.848.32-1.136,1.024-1.68l.672-.528A2.952,2.952,0,0,0,8.336-8.464c0-1.744-1.344-2.9-3.344-2.9A3.125,3.125,0,0,0,1.568-8.128H2.944A1.848,1.848,0,0,1,4.992-10.16,1.7,1.7,0,0,1,6.928-8.432,1.96,1.96,0,0,1,6.1-6.784l-.512.4a2.825,2.825,0,0,0-1.44,2.576ZM3.92,0H5.648V-1.76H3.92Z",
    transform: "translate(240.048 612.68)",
    fill: "#8b8b8b"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_3181",
    "data-name": "Ellipse 3181",
    transform: "translate(233 595)",
    fill: "none",
    stroke: "#8b8b8b",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 12,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 11.5,
    fill: "none"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUnknownNew);
export default __webpack_public_path__ + "static/media/unknown_new.727c7fce102dd97214c4af203694f4da.svg";
export { ForwardRef as ReactComponent };